@if (crumbs().length) {
  <ol class="app-breadcrumbs__list">
    @for (c of crumbs(); track c.label; let last = $last) {
      <li class="app-breadcrumbs__item">
        @if (c.url && !last) {
          <a [routerLink]="c.url" class="app-breadcrumbs__link">{{ c.label }}</a>
          <span class="app-breadcrumbs__sep" aria-hidden="true">/</span>
        } @else {
          <span class="app-breadcrumbs__current" aria-current="page">{{ c.label }}</span>
        }
      </li>
    }
  </ol>
}
